module.exports = __webpack_public_path__ + "static/img/业务生态-产业项目布局-四屏-53.270fafb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/业务生态-产业项目布局-四屏-53.png
// module id = H/Gn
// module chunks = 0